import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './PaymentSuccessPage.css';

const PaymentSuccessPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { tier, amount, paymentIntent, error } = location.state || {};

  useEffect(() => {
    // Redirect if no payment data
    if (!tier && !error) {
      navigate('/');
    }
  }, [tier, error, navigate]);

  useEffect(() => {
    // Confetti effect
    const duration = 3 * 1000;
    const animationEnd = Date.now() + duration;
    const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

    function randomInRange(min, max) {
      return Math.random() * (max - min) + min;
    }

    const interval = setInterval(function() {
      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        return clearInterval(interval);
      }

      const particleCount = 50 * (timeLeft / duration);

      // Create confetti effect (you'll need to install canvas-confetti)
      // Or use CSS animation as fallback
      if (window.confetti) {
        window.confetti(Object.assign({}, defaults, {
          particleCount,
          origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 }
        }));
        window.confetti(Object.assign({}, defaults, {
          particleCount,
          origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 }
        }));
      }
    }, 250);

    return () => clearInterval(interval);
  }, []);

  if (error) {
    return (
      <div className="payment-success-page error">
        <div className="success-container">
          <div className="success-icon error-icon">⚠️</div>
          <h1>Payment Issue</h1>
          <p className="error-message">{error}</p>
          <div className="action-buttons">
            <button onClick={() => navigate('/settings')} className="primary-btn">
              Go to Settings
            </button>
            <button onClick={() => navigate('/')} className="secondary-btn">
              Back to Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="payment-success-page">
      <div className="success-container">
        <div className="success-animation">
          <div className="success-icon">✓</div>
          <div className="success-circle"></div>
        </div>

        <h1>Payment Successful!</h1>
        <p className="success-message">
          Welcome to the <strong>{tier}</strong> Subscription Plan!
        </p>

        <div className="payment-details-card">
          <h2>Payment Confirmation</h2>
          <div className="detail-row">
            <span>Plan</span>
            <span className="detail-value">{tier}</span>
          </div>
          <div className="detail-row">
            <span>Amount Paid</span>
            <span className="detail-value">${amount}</span>
          </div>
          {paymentIntent && (
            <div className="detail-row">
              <span>Transaction ID</span>
              <span className="detail-value transaction-id">
                {paymentIntent/*.id*/}
              </span>
            </div>
          )}
          <div className="detail-row">
            <span>Billing</span>
            <span className="detail-value">Monthly</span>
          </div>
        </div>

        <div className="next-steps-card">
          <h3>🎉 What's Next?</h3>
          <ul className="next-steps-list">
            <li>
              <span className="step-icon">✓</span>
              <span>Your account has been upgraded</span>
            </li>
            <li>
              <span className="step-icon">✓</span>
              <span>All premium features are now unlocked</span>
            </li>
            <li>
              <span className="step-icon">✓</span>
              <span>A confirmation email has been sent</span>
            </li>
            <li>
              <span className="step-icon">📧</span>
              <span>Receipt will arrive within 24 hours</span>
            </li>
          </ul>
        </div>

        <div className="action-buttons">
          <button
            onClick={() => navigate('/app')}
            className="primary-btn"
          >
            Try Upgraded Features
          </button>
          <button
            onClick={() => navigate('/settings')}
            className="secondary-btn"
          >
            Go to Settings
          </button>
        </div>

        <div className="support-info">
          <p>
            Need help? <a href="/support">Contact Support</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;